import { Button } from '@kcftech/design-system';
import { IUserContext } from 'contexts/UserContext';
import { logout } from 'pages/Login/Login';
import styled from 'styled-components';

export type UserMenuOptionsProps = Readonly<{
    userContext: IUserContext;
    onChangePasswordClick: () => void;
}>;

const UserMenuOptionsContainer = styled.div`
    justify-content: space-between;
`;

const UserMenuOption = styled.div`
    display: flex;
`;

export function UserMenuOptions({
    userContext,
    onChangePasswordClick,
}: UserMenuOptionsProps) {
    return (
        <UserMenuOptionsContainer className="flex-row">
            {!userContext.user?.IdentityProviderName && (
                <UserMenuOption>
                    <Button
                        appearance="secondary"
                        spacing="compact"
                        onClick={onChangePasswordClick}
                        type="submit"
                    >
                        Change Password
                    </Button>
                </UserMenuOption>
            )}
            <UserMenuOption>
                <Button spacing="compact" onClick={() => logout(true)} type="submit">
                    Log Off
                </Button>
            </UserMenuOption>
        </UserMenuOptionsContainer>
    );
}
